import type { Payload } from '@/core/content/types';
import type { ErrorCorrection } from '@/core/qr/encode';

export type TextAlign = 'left' | 'center' | 'right';
export type OutputFormat = 'png' | 'jpeg' | 'svg';

/**
 * Минимальное защитное поле вокруг матрицы, в модулях.
 * Требование QR-спецификации; проверяется в runtime, а не только типом.
 */
export const MIN_QUIET_ZONE = 4;

export type CaptionConfig = {
  text: string;
  fontId: string;
  fontRevision: string;
  weight: number;
  /** Кегль в пикселях выходного документа. */
  size: number;
  align: TextAlign;
};

export type Project = {
  schemaVersion: 1;
  payload: Payload;
  qr: {
    errorCorrection: ErrorCorrection;
    quietZoneModules: number;
    foreground: string;
    background: string;
  };
  template: { id: string; version: number };
  paletteId: string;
  title: string;
  caption: CaptionConfig;
  note: string;
  output: {
    widthPx: number;
    format: OutputFormat;
    /** false — экспортируем только QR с защитным полем, без карточки. */
    includeDecoration: boolean;
    /** Качество JPEG в диапазоне 0..1. */
    jpegQuality: number;
    /** Прозрачный фон за пределами поля QR (только PNG и SVG). */
    transparentBackground: boolean;
  };
};

/** Геометрия расчёта размера под печать. */
export type PrintSpec = { millimeters: number; ppi: number };

export function pxFromMillimeters({ millimeters, ppi }: PrintSpec): number {
  return Math.round((millimeters / 25.4) * ppi);
}
